import type { PaginationData } from '@/utils/request';
import { request } from '@/utils/request';

/**
 * 获取采购订单（积分明细列表）
 */
export function getSellerOrderList(data: API.GetSellerOrderListParams) {
  return request<PaginationData<API.SellerOrder[]>>({
    url: '/v1/seller/sellerOrder/list',
    method: 'GET',
    params: data,
  });
}

/**
 * 获取充值金额对应的可增加积分
 */
export function getAddRankScore(data: API.RankScoreParams) {
  return request<API.RankScoreResult>({
    url: '/v1/seller/sellerOrder/getAddRankScore',
    method: 'POST',
    data,
  });
}

/**
 * 卖家支付
 */
export function sellerPay(data: API.PayParam) {
  return request<any>({
    url: '/seller/erpSellerAmount/pay',
    method: 'post',
    data,
  });
}
